export const PROJECT_MODE = {
  DEV_MODE: "development",
  PROD_MODE: "production",
};

export const BASE_API_URL = import.meta.env.VITE_API_URL;
export const SENRTY_DSN = import.meta.env.VITE_SENRTY_DSN || "";
export const TELEGRAM_BOT_LINK = import.meta.env.VITE_APP_BOT_LINK;
export const MANIFEST_URL = import.meta.env.VITE_MANIFEST_URL || "";
export const LINK_SHARED = `https://t.me/${import.meta.env.VITE_BOT_ADDRESS}?start=`;
export const TON_API_URL = import.meta.env.VITE_TONAPI_URL;
export const TON_VIEWER_URL = import.meta.env.VITE_TONVIEWER;
export const DEV_MODE = process.env.NODE_ENV || PROJECT_MODE.DEV_MODE;
export const SUPPORT_LINK = import.meta.env.VITE_SUPPORT_LINK || "";
export const POLICY_LINK = import.meta.env.VITE_POLICY_LINK || "";
export const TERMS_USER_LINK = import.meta.env.VITE_TERMS_USER_LINK || "";
